import { render, staticRenderFns } from "./MSOProductBase.vue?vue&type=template&id=98084578&"
import script from "./MSOProductBase.vue?vue&type=script&lang=js&"
export * from "./MSOProductBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports